import { Component, OnInit } from '@angular/core';
import { AdmisionEntity, ReporteAdmisionEntity, ServicioAdmisionesService, AdmisionesEmpresaEntity, AdmisionesPuntoAtencionEntity, AdmisionesServicioDetalleEntity, EdadEntity, SuministroEntity, SuministrosAgrupadosEntity, ConceptosEntity } from '../../../../services/servicio-admisiones.service';
import { LoginEntity, ServicioLoginService } from '../../../../services/servicio-login.service';
import { ActivatedRoute } from '@angular/router';
import { ImagesService } from '../../../../services/utils/images.service';
import { AlertModel, ETipoAlert } from '../../../shared/alert/alert.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-reporte-admision2',
  templateUrl: './reporte-admision2.component.html',
  styleUrls: ['./reporte-admision2.component.css']
})
export class ReporteAdmision2Component implements OnInit {

  loading: boolean;
  error: boolean;

  mensajeError: AlertModel = new AlertModel();

  mensajeLoading: string;
  logo: string;

  fechaImpresion: Date;

  admision: AdmisionEntity;
  admisionEmpresa: AdmisionesEmpresaEntity;
  admisionPuntoatencion: AdmisionesPuntoAtencionEntity;
  admisionDetalles: AdmisionesServicioDetalleEntity[] = [];
  suministros: SuministroEntity[] = [];
  conceptos: ConceptosEntity[] = [];
  suministrosAgrupados: SuministrosAgrupadosEntity;
  objectAdmision: ReporteAdmisionEntity = {};
  cuotaModeradora:ConceptosEntity;
  usuario: LoginEntity;

  constructor(private activatedRoute: ActivatedRoute,
              private servicioAdmision: ServicioAdmisionesService,
              private servicioLogin: ServicioLoginService,
              private servicioImagenes: ImagesService) {
    this.activatedRoute.params.subscribe(params => {
      this.objectAdmision.codigo = params['codigoBaseDatos'];
      this.objectAdmision.uncoSede = Number(params['uncoSede']);
      this.objectAdmision.uncoLogin = Number(params['uncoLogin']);
      this.objectAdmision.uncoAdmision = Number(params['uncoAdmision']);
    });
  }

  ngOnInit() {
    this.onGenerate();
  }

  onGenerate() {
    this.loading = true;
    this.mensajeError = new AlertModel();
    this.fechaImpresion = new Date();
    this.getLogo(this.objectAdmision.codigo);
  }

  onFiltrosCompletados() {
    this.onGenerate();
  }

  async getLogo(codigoBaseDatos: string) {
    try {
      this.mensajeLoading = 'Cargando información de la entidad ...';
      const request = await this.servicioImagenes.getLogo(codigoBaseDatos);
      request.subscribe((data: any) => {
        this.logo = data.source;
        this.getLogin(codigoBaseDatos, this.objectAdmision.uncoLogin);
      }, (err: HttpErrorResponse) => {
        console.error('Reporte-Admision2.getLogo()', err);
        this.logo = '';
        this.setError('Error al intentar obtener el logo de la entidad, verifique conexión a internet e intente de nuevo.');
      })
    } catch(e) {
      console.error('Reporte-Admision2.getLogo()', e);
      this.logo = '';
      this.setError('Error grave al intentar obtener el logo de la entidad, reporte el caso al administrador.');
    }
  }

  async getLogin(codigo: string, uncoLogin: number) {
    try {
      this.mensajeLoading = 'Cargando información del usuario ...';
      const request = await this.servicioLogin.getUsuario(codigo, uncoLogin);
      request.subscribe((data: LoginEntity) => {
        this.usuario = data;
        this.getAdmision(codigo, this.objectAdmision.uncoAdmision);
      }, (err: HttpErrorResponse) => {
        console.error('Reporte-Admision2.getLogin()', err);
        this.usuario = null;
        this.setError('Error al intentar obtener información del usuario, verifique conexión a internet e intente de nuevo.');
      })
    } catch(e) {
      console.error('Reporte-Admision2.getLogin()', e);
      this.usuario = null;
      this.setError('Error grave al intentar obtener información del usuario, reporte el caso al administrador.');
    }
  }

  async getAdmision(codigo: string, uncoAdmision: number) {
    try {
      this.mensajeLoading = 'Cargando información de la admisión ...';
      const request = await this.servicioAdmision.getAdmision(codigo, uncoAdmision);
      request.subscribe((data: AdmisionEntity) => {
        this.setAdmision(data);
        this.getSuministros(codigo,uncoAdmision);
      }, (err: HttpErrorResponse) => {
        console.error('Reporte-Admision2.getAdmision()', err);
        this.setAdmision(null);
        this.setError('Error al intentar obtener información de la admisión, verifique conexión a internet e intente de nuevo.');
      })
    } catch(e) {
      console.error('Reporte-Admision2.getAdmision()', e);
      this.setAdmision(null);
      this.setError('Error grave al intentar obtener información de la admisión, reporte el caso al administrador.');
    }
  }

  async getSuministros(codigo: string, uncoAdmision: number) {
    try {
      this.mensajeLoading = 'Cargando información de los suministros ...';
      const request = await this.servicioAdmision.getSuministros(codigo, uncoAdmision);
      request.subscribe((data: SuministroEntity[]) => {
        this.suministros = data;
        if(data !== null && data.length > 0) {
          this.suministrosAgrupados = data.reduce((prevValue, currentValue) => {
            const val = currentValue['numeroSolicitud'];
            prevValue[val] = (prevValue[val] || []).concat(currentValue);
            return prevValue;
          }, {});
        }
        this.getConceptos(codigo,uncoAdmision);
      }, (err: HttpErrorResponse) => {
        console.error('Reporte-Admision2.getSuministros()', err);
        this.setError('Error al intentar obtener información de los suministros, verifique conexión a internet e intente de nuevo.');
      })
    } catch(e) {
      console.error('Reporte-Admision2.getSuministros()', e);
      this.setError('Error grave al intentar obtener información de los suministros, reporte el caso al administrador.');
    }
  }

  async getConceptos(codigo: string, uncoAdmision: number) {
    try {
      this.mensajeLoading = 'Cargando conceptos de la admisión ...';
      const request = await this.servicioAdmision.getConceptos(codigo, uncoAdmision);
      request.subscribe((data: ConceptosEntity[]) => {
        this.conceptos = data;
        if(data !== null) {
          this.cuotaModeradora = this.getConcepto('Cargos al Afiliado');
        } else {
          this.cuotaModeradora = {
            descripcion: '',
            signo: '',
            unco: 0,
            valor: 0
          }
        }
        this.loading = false;
      }, (err: HttpErrorResponse) => {
        console.error('Reporte-Admision2.getConceptos()', err);
        this.setError('Error al intentar obtener información de la admisión, verifique conexión a internet e intente de nuevo.');
      })
    } catch(e) {
      console.error('Reporte-Admision2.getConceptos()', e);
      this.setAdmision(null);
      this.setError('Error grave al intentar obtener información de la admisión, reporte el caso al administrador.');
    }
  }

  // Auxiliares

  isReady() {
    return !(this.loading || this.error);
  }

  setError(mensaje: string) {
    this.loading = false;
    this.error = true;
    this.mensajeError.mensaje = mensaje;
    this.mensajeError.tipo = ETipoAlert.danger;
    this.mensajeError.visible = true;
    this.mensajeError.icon = 'fa fa-exclamation-triangle mr-2';
  }

  setAdmision(admision: AdmisionEntity) {
    if (admision && admision.unco > 0) {
      this.admision = admision;
      this.setAdmisionEmpresa(admision);
    } else {
      this.admision = null;
      this.admisionEmpresa = null;
      this.setError('No fue posible obtener información de la admisión, intente de nuevo de lo contrario comuniquese con el administrador de sistema.');
    }
  }

  setAdmisionEmpresa(adm: AdmisionEntity) {
    if (adm.admisionesEmpresas && adm.admisionesEmpresas.length > 0) {
      this.admisionEmpresa = adm.admisionesEmpresas[0];
      this.setAdmisionPuntoAtencion(this.admisionEmpresa);
    }
  }

  setAdmisionPuntoAtencion(adm: AdmisionesEmpresaEntity) {
    if (adm.admisionesPuntoAtencion && adm.admisionesPuntoAtencion.length > 0) {
      this.admisionPuntoatencion = adm.admisionesPuntoAtencion[0];
      this.admisionDetalles = this.admisionPuntoatencion.admisionesServicioDetalle;
    }
  }


  // Auxiliares reporte
  getNombreEmpresa() {
    return this.admisionEmpresa ? this.admisionEmpresa.empresa.descripcionLarga : '--';
  }

  getDireccion() {
    return this.admisionEmpresa ? this.admisionEmpresa.empresa.direccion : '--';
  }

  getConsecutivoAdmision() {
    if (this.admision && this.admision.unco > 0) {
      const prefijo = this.admision.prefijo;
      const consecutivo = this.admision.consecutivo;
      return `${prefijo} - ${consecutivo}`;
    } else {
      return '--';
    }
  }

  getNit() {
    return this.admisionEmpresa ? this.admisionEmpresa.empresa.numeroIdentificacion : '--';
  }

  getTelefono() {
    if (this.admisionEmpresa) {
      const pbx = this.admisionEmpresa.empresa.telefonoPbx;
      const movil = this.admisionEmpresa.empresa.telefonoMovil;
      return `${pbx ? pbx : ''}${movil ? (pbx ? ' - ' + movil : movil ) : ''}`;
    } else {
      return '--';
    }
  }

  getFechaAdmision() {
    return this.admision ? this.admision.fechaAdmision : '';
  }

  getFechaCreacion() {
    return this.admision ? this.admision.fechaCreacion : '';
  }

  getNumeroAutorizacion(): string {
    if (this.admisionDetalles && this.admisionDetalles.length > 0) {
      for(let i = 0; i < this.admisionDetalles.length; i++) {
        const detalle = this.admisionDetalles[i];
        if(detalle && detalle.numeroAutorizacion && detalle.numeroAutorizacion.trim().length > 0) {
          return detalle.numeroAutorizacion;
        }
      }
    }
    return  '--';
  }

  getNombrePaciente() {
    if (this.admision && this.admision.afiliado) {
      const primerNombre = this.admision.afiliado.primerNombre;
      const segundoNombre = this.admision.afiliado.segundoNombre;
      const primerApellido = this.admision.afiliado.primerApellido;
      const segundoApellido = this.admision.afiliado.segundoApellido;
      return `${primerApellido}${segundoApellido ? ' ' + segundoApellido : ''}${primerNombre ? ' ' + primerNombre : ''}${segundoNombre ? ' ' + segundoNombre : ''}`
    }else {
      return '--';
    }
  }

  getIdentificacionPaciente() {
    if (this.admision && this.admision.afiliado) {
      const codigo = this.admision.afiliado.tipoDocumento;
      const numero = this.admision.afiliado.numeroIdentificacion;
      return `${codigo} - ${numero}`;
    } else {
      return '--';
    }
  }

  getTelefonoPaciente() {
    if (this.admision && this.admision.afiliado) {
      const telefono = this.admision.afiliado.telefono;
      const movil = this.admision.afiliado.celular;
      return `${telefono ? telefono : ''}${movil ? ' ' + (telefono ? ' - ' + movil : movil) : ''}`
    } else {
      return '--';
    }
  }

  getDireccionPaciente() {
    return this.admision && this.admision.afiliado ? this.admision.afiliado.direccion : '--';
  }

  getBarrioPaciente() {
    return this.admision && this.admision.afiliado ? this.admision.afiliado.barrio : '--';
  }

  getCiudadPaciente() {
    return this.admision && this.admision.afiliado ? this.admision.afiliado.municipio : '--';
  }

  getGeneroPaciente() {
    if (this.admision && this.admision.afiliado) {
      const codigo = this.admision.afiliado.codigoSexo.toUpperCase();
      switch(codigo) {
        case 'M': return 'Masculino';
        case 'F': return 'Femenino';
        case 'A': return 'Ambos';
        default: return '--'
      }
    }
  }

  getFechaPaciente() {
    if (this.admision && this.admision.afiliado) {
      return this.admision.afiliado.fechaNacimiento;
    } else {
      return null;
    }
  }

  getEdad() {
    if (this.admision && this.admision.afiliado && this.admision.afiliado.edad) {
      const edad: EdadEntity = this.admision.afiliado.edad;
      return `${edad.anos} Años ${edad.meses} meses ${edad.dias} días.`
    }
    return '';
  }

  getTipoPaciente() {
    return this.admision && this.admision.afiliado && this.admision.afiliado.tipoAfiliado ? this.admision.afiliado.tipoAfiliado : '--';
  }

  getNombreResponsable() {
    return this.admision && this.admision.afiliado && this.admision.afiliado.nombreResponsable ? this.admision.afiliado.nombreResponsable : '--';
  }

  getTelefonoResponsable() {
    return this.admision && this.admision.afiliado && this.admision.afiliado.telefonoResponsable ? this.admision.afiliado.telefonoResponsable : '--';
  }

  getDiagnostico() {
    if (this.admision && this.admision.diagnosticoIngreso) {
      const dx = this.admision.diagnosticoIngreso;
      return `(${dx.codigoDiagnostico}) ${dx.descripcion}`
    } else {
      return '--';
    }
  }

  getFechaInicia() {
    return this.admision ? this.admision.fechaInicioServicio : '--';
  }

  getFechaFin() {
    return this.admision ? this.admision.fechaFinalServicio : '--';
  }

  getObservacion() {
    return this.admision && this.admision.observacion ? this.admision.observacion : '--';
  }

  getUsuarioRealiza() {
    return this.admision && this.admision.usuarioRealiza ? this.admision.usuarioRealiza.descripcion : '--';
  }

  getPrestador(d: AdmisionesServicioDetalleEntity) {
    const nombres = d.profesionalRealiza.nombres;
    const apellidos = d.profesionalRealiza.apellidos;
    return `${nombres} ${apellidos}`;
  }

  getConcepto(descripcion: string):ConceptosEntity {
    if(this.conceptos !== null && this.conceptos !== undefined) {
      return this.conceptos.find((conc,index)=> conc.descripcion === descripcion);
    }
    return null;
  }

}
